<template>
  <div class="Box">
    <div :class="screenWidth >= 1030 ? 'top_title' : 'mt20'">
      <div>
        <span class="top_title_top">{{ $t('collectionCenter.transitCenterInventoryDashboard') }}</span><!-- 转运中心库存监控看板 -->
        <br>
        <!-- 核心目标：监控每个转运中心每日入库票数、出库票数，以及当前仍停留在转运中心未发出的库存票数。 -->
        <span class="top_title_bottom">{{ $t('collectionCenter.hubVal1') }}</span>
      </div>
      <div class="top_title_time">
        <!-- 数据更新时间 -->
        {{ $t('collectionCenter.hubVal2') }}：{{ updateTime || '--' }}
        <span class="top_title_time_split">|</span>
        {{ $t('collectionCenter.hubVal3') }}<!-- 自动刷新：1小时 -->
      </div>
    </div>
    <el-form class="form_box">
      <el-row type="flex" justify="left" style="flex-wrap: wrap;gap: 10px">
        <el-col :span="screenWidth >= 1030 ? 5 : 24">
          <!--  大区  -->
          <el-form-item :label="$t('collectionCenter.region')">
            <el-select
              v-model="queryForm.params.areaNameList"
              :placeholder="$t('collectionCenter.allRegions')"
              clearable filterable size="small"
              style="width: 100%"
              @change="changeRegion"
            >
              <el-option
                v-for="item in regionData"
                :key="item.id"
                :label="item.zhName + '（' + item.puName + '）'"
                :value="item.zhName"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="screenWidth >= 1030 ? 5 : 24">
          <!-- 州 -->
          <el-form-item :label="$t('collectionCenter.state')">
            <el-select
              v-model="queryForm.params.stateList"
              :placeholder="$t('collectionCenter.allStates')"
              clearable filterable
              multiple collapse-tags
              style="width: 100%" size="small"
              @change="changeState"
            >
              <el-option
                v-for="(item, idx) in stateData"
                :key="idx"
                :label="item.label"
                :value="item.label"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="screenWidth >= 1030 ? 5 : 24">
          <!-- 转运中心类型 -->
          <el-form-item :label="$t('collectionCenter.transitCenterType')">
            <el-select
              v-model="queryForm.params.hubLevelList"
              :placeholder="$t('collectionCenter.allTypes')"
              clearable filterable
              style="width: 100%" size="small"
            >
              <el-option :label="$t('collectionCenter.hubVal28')" value="lv1" />
              <el-option :label="$t('collectionCenter.hubVal29')" value="lv2" />
              <el-option :label="$t('collectionCenter.hubVal30')" value="lv3" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="screenWidth >= 1030 ? 5 : 24">
          <!-- 转运中心 -->
          <el-form-item :label="$t('collectionCenter.transferCenter')">
            <el-select
              v-model="queryForm.params.departmentList"
              :placeholder="$t('collectionCenter.hubVal31')"
              clearable filterable
              multiple collapse-tags
              style="width: 100%" size="small"
            >
              <el-option
                v-for="(item, index) in departmentData"
                :key="index"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="screenWidth >= 1030 ? 2 : 24">
          <!-- 查询 -->
          <el-button
            type="primary" size="small" :class="screenWidth >= 1030 ? 'search_btn' : 'allW'"
            style="box-shadow: 0 0 0 #fff"
            @click="searchForm"
          >{{ $t('collectionCenter.search') }}</el-button>
        </el-col>
      </el-row>
    </el-form>
    <div class="title_bw">
      <span class="title_bw_bold ind">{{ $t('collectionCenter.hubVal4') }}</span><!-- 一、全局概览 -->
      <span class="title_bw_tips">{{ $t('collectionCenter.hubVal5') }}</span><!-- 快速查看当日流入、流出、当前库存压力和分拣出库效率 -->
    </div>
    <div :class="screenWidth >= 1030 ? 'grid-seven' : ''">
      <div v-for="(item, i) in globalOverviewData" :key="i" :class="screenWidth >= 1030 ? 'grid-item7' : 'gi7'">
        <span class="grid_item_gray">{{ item.data1 }}</span><br>
        <span class="grid_item_bold" :style="{ color: item.color }">
          {{ globalOverviewValue[item.data2] ? formatThousand(globalOverviewValue[item.data2]) : 0 }}
          {{
            item.data2 === 'stockTurnoverDays' ? $t('orderCenterCont.days') :
            item.data2 === 'avgInventoryHours' ? 'h' :
            item.data2 === 'inventoryAgingRate' ? '%' : ''
          }}
        </span><br>
        <span class="grid_item_gray">{{ item.data3 }}</span>
      </div>
    </div>
    <div class="title_bw">
      <span class="title_bw_bold ind">{{ $t('collectionCenter.hubVal6') }}</span><!-- 二、库存年龄与层级库存 -->
      <span class="title_bw_tips">{{ $t('collectionCenter.hubVal7') }}</span><!-- 重点判断当前库存是否开始老化、是否集中在某类转运中心 -->
    </div>
    <el-row :style="screenWidth >= 1030 ? 'display: flex;gap: 10px' : ''">
      <el-col :span="screenWidth >= 1030 ? 13 : 24" class="box_class">
        <span class="title_bw_bold">{{ $t('collectionCenter.hubVal8') }}</span><br><!-- 库存年龄结构 -->
        <span class="title_bw_tips">{{ $t('collectionCenter.hubVal9') }}</span><!-- 按当前库存包裹的在库时长统计；库存时长 = 当前时间 - 转运中心入库时间。 -->
        <div class="grid-five">
          <div
            v-for="(item, i) in ageStructureData" :key="i"
            :class="screenWidth >= 1030 ? 'grid-item5' : 'gi5'" :style="{ background: item.background, 'border-color': item.borderColor }"
          >
            <span class="grid_item_gray">{{ item.bucketName }}</span><br>
            <span class="grid_item_bold">{{ formatThousand(item.ticketCount) || 0 }}</span><br>
            <span class="grid_item_gray">{{ formatThousand(item.rate) || 0 }}%</span>
          </div>
        </div>

        <div class="bg_box">
          <span
            class="bg_green" :style="{ width: lineData.length > 0 ? lineData[0] : 0 }"
            @mousemove="showEchartsTooltip($event, ageStructureData[0], 'bg_green')"
            @mouseleave="hideEchartsTooltip"
          />
          <span
            class="bg_blue" :style="{ width: lineData.length > 0 ? lineData[1] : 0 }"
            @mousemove="showEchartsTooltip($event, ageStructureData[1], 'bg_blue')"
            @mouseleave="hideEchartsTooltip"
          />
          <span
            class="bg_Pumpkin" :style="{ width: lineData.length > 0 ? lineData[2] : 0 }"
            @mousemove="showEchartsTooltip($event, ageStructureData[2], 'bg_Pumpkin')"
            @mouseleave="hideEchartsTooltip"
          />
          <span
            class="bg_orange" :style="{ width: lineData.length > 0 ? lineData[3] : 0 }"
            @mousemove="showEchartsTooltip($event, ageStructureData[3], 'bg_orange')"
            @mouseleave="hideEchartsTooltip"
          />
          <span
            class="bg_red" :style="{ width: lineData.length > 0 ? lineData[4] : 0 }"
            @mousemove="showEchartsTooltip($event, ageStructureData[4], 'bg_red')"
            @mouseleave="hideEchartsTooltip"
          />
        </div>
        <div class="bg_card">
          <span><span class="bg_green color_card" /> ≤24h</span>
          <span><span class="bg_blue color_card" /> 24~48h</span>
          <span><span class="bg_Pumpkin color_card" /> 48~72h</span>
          <span><span class="bg_orange color_card" /> 3~7{{ $t('basicData.NumberOfDays') }}</span>
          <span><span class="bg_red color_card" /> >7{{ $t('basicData.NumberOfDays') }}</span>
        </div>
      </el-col>
      <el-col :span="screenWidth >= 1030 ? 11 : 24" class="box_class" :style="screenWidth < 1030 ? 'margin-top: 10px': ''">
        <span class="title_bw_bold">{{ $t('collectionCenter.hubVal10') }}</span><br><!-- 转运中心层级库存 -->
        <span class="title_bw_tips">{{ $t('collectionCenter.hubVal11') }}</span><!-- 按转运中心层级汇总当前库存票数。 -->
        <el-row v-for="(item, i) in levelData" :key="i" class="progress_class">
          <el-col :span="4" class="progress_title">{{ item.title }}</el-col>
          <el-col :span="16">
            <el-progress
              :stroke-width="12" :show-text="false" color="#ea580c"
              :percentage="item.progress"
            />
          </el-col>
          <el-col :span="3" class="progress_num">{{ formatThousand(item.currentTicketCount) }}</el-col>
        </el-row>
        <div class="progress_gray_box">
          <span class="progress_gray_text">{{ $t('collectionCenter.hubVal12') }}</span><!-- 判断重点： -->
          {{ $t('collectionCenter.hubVal13') }}<!-- 如果库存主要集中在一级转运中心，需要优先检查干线出车、装车效率和下级转运承接能力。 -->
        </div>
      </el-col>
    </el-row>
    <el-row :style="screenWidth >= 1030 ? 'display: flex;gap: 10px; margin-top: 10px' : 'margin-top: 10px'">
      <el-col :span="screenWidth >= 1030 ? 11 : 24" class="box_class">
        <span class="title_bw_bold">{{ $t('collectionCenter.hubVal14') }}</span><br><!-- 高库存风险HUB TOP10 -->
        <span class="title_bw_tips">{{ $t('collectionCenter.hubVal15') }}</span><!-- 按照库存周转天数倒序排列，库存周转天数=当前库存票数÷近7日日均出库票数。 -->
        <ul v-if="highRiskData && highRiskData.length > 0" class="risk_box">
          <li v-for="(item, i) in highRiskData" :key="i" class="risk_item">
            <span class="risk_index">{{ i + 1 }}</span>
            <div class="risk_content">
              <span class="risk_name">{{ item.hubName }}</span><br>
              <span class="title_bw_tips">
                {{ $t('collectionCenter.hubVal16') }} {{ formatThousand(item.currentTicketCount) || 0 }}<!-- 当前库存 -->
                <span class="risk_num">|</span>
                {{ $t('collectionCenter.hubVal17') }} {{ formatThousand(item.avgDailyOutboundTicketCount) || 0 }}<!-- 近7日日均出库 -->
              </span>
            </div>
            <span
              class="risk_day"
              :style="{
                background: item.stockTurnoverDays <= 1 ? '#ecfdf3' : item.stockTurnoverDays <= 2 ? '#fdf8ec' : item.stockTurnoverDays <= 3 ? '#fffaeb' : '#fef3f2',
                color: item.stockTurnoverDays <= 1 ? '#079455' : item.stockTurnoverDays <= 2 ? '#dcca03' : item.stockTurnoverDays <= 3 ? '#dc6803' : '#d92d20'
              }"
            >{{ item.stockTurnoverDays }}{{ $t('orderCenterCont.days') }}</span>
          </li>
        </ul>
        <div v-else style="margin: 20px auto;color: #909399;text-align: center;font-size: 14px"> - {{ $t('collectionCenter.nullMsg') }} -</div>
      </el-col>
      <el-col :span="screenWidth >= 1030 ? 13 : 24" class="box_class" :style="screenWidth < 1030 ? 'margin-top: 10px': ''">
        <span class="title_bw_bold">{{ $t('collectionCenter.hubVal18') }}</span><br><!-- 库存老化风险HUB TOP10 -->
        <span class="title_bw_tips">{{ $t('collectionCenter.hubVal19') }}</span><!-- 按照超过48小时库存票数÷实时库存票数，作用：衡量库存积压风险 -->
        <ul v-if="agingRiskData && agingRiskData.length > 0" class="risk_box">
          <li v-for="(item, i) in agingRiskData" :key="i" class="risk_item">
            <span class="risk_index">{{ i + 1 }}</span>
            <div class="risk_content ">
              <span class="risk_name">{{ item.hubName }}</span><br>
              <span
                :style="{
                  'font-weight': 'bold',
                  'font-size': '14px',
                  color: item.inventoryAgingRate <= 5 ? '#079455' : item.inventoryAgingRate <= 10 ? '#dcca03' : item.inventoryAgingRate <= 20 ? '#dc6803' : '#d92d20'
                }"
              >{{ item.inventoryAgingRate }} %</span>
            </div>
            <span class="title_bw_tips" style="margin-right: 10px">
              <span style="font-size: 12px">48~72h</span> {{ formatThousand(item.inventory48To72hCount) || 0 }}
              <span class="risk_num">|</span>
              <span style="font-size: 12px">3~7{{ $t('basicData.NumberOfDays') }}</span> {{ formatThousand(item.inventory3To7dCount) || 0 }}
              <span class="risk_num">|</span>
              <span style="font-size: 12px">>7{{ $t('basicData.NumberOfDays') }}</span> {{ formatThousand(item.inventoryGt7dCount) || 0 }}
            </span>
            <span
              class="risk_day"
              :style="{
                background: item.inventoryAgingRate <= 5 ? '#ecfdf3' : item.inventoryAgingRate <= 10 ? '#fdf8ec' : item.inventoryAgingRate <= 20 ? '#fffaeb' : '#fef3f2',
                color: item.inventoryAgingRate <= 5 ? '#079455' : item.inventoryAgingRate <= 10 ? '#dcca03' : item.inventoryAgingRate <= 20 ? '#dc6803' : '#d92d20'
              }"
            >{{ formatThousand(item.inventoryAgingCount) }}</span>
          </li>
        </ul>
        <div v-else style="margin: 20px auto;color: #909399;text-align: center;font-size: 14px"> - {{ $t('collectionCenter.nullMsg') }} -</div>
      </el-col>
    </el-row>

    <div class="title_bw">
      <span class="title_bw_bold ind">{{ $t('collectionCenter.hubVal20') }}</span><!-- 三、近7日入库/出库趋势 -->
      <span class="title_bw_tips">{{ $t('collectionCenter.hubVal21') }}</span><!-- 用于判断库存是否持续积压 -->
    </div>
    <div class="box_class">
      <span class="title_bw_tips">{{ $t('collectionCenter.hubVal22') }}</span><!-- 库存票数为当天23:59:59的实施库存数量 -->
      <div v-if="Object.keys(barData).length > 0"><barChart :chart-data="barData" /></div>
      <div v-else style="margin: 20px auto;color: #909399;text-align: center;font-size: 14px"> - {{ $t('collectionCenter.nullMsg') }} -</div>
    </div>

    <div class="box_class" style="margin-top: 20px; padding: 0 !important">
      <div style="display: flex;justify-content: space-between;align-items: center; padding: 10px; box-sizing: border-box">
        <div>
          <span class="title_bw_bold">{{ $t('collectionCenter.hubVal23') }}</span><br><!-- 四、转运中心明细 -->
          <span class="title_bw_tips">{{ $t('collectionCenter.hubVal24') }}</span><!-- 按转运中心展示每日入库、出库、库存、库存周转天数和近7天平均在库时长。 -->
        </div>
        <div style="float: right">
          <el-button size="small" @click="exportData('hubStockDetail')">{{ $t('collectionCenter.hubVal25') }}</el-button><!-- 导出列表信息 -->
          <el-button size="small" @click="exportData('hubStockRealtimeWaybillDetail')">{{ $t('collectionCenter.exportDetails') }}</el-button><!-- 导出明细 -->
        </div>
      </div>
      <hubTable :table-data="tableData" />
    </div>
    <div class="progress_gray_box">
      <span class="progress_gray_text">{{ $t('collectionCenter.hubVal26') }}：</span><!-- 统计口径 -->
      <!-- 入库票数=统计日期内完成转运中心入库扫描的包裹数；
          出库票数=统计日期内完成转运中心出库扫描/装车发出的包裹数；
          当前库存票数=已入库但尚未出库的包裹数；
          净增库存=出库票数-入库票数；
          趋势图库存票数=当天23:59:59的实际库存减取净增库存；
          库存周转天数=当前库存票数÷近7日日均出库票数；
          库存老化率=超过72小时库存票数÷实时库存票数；
          近7天平均在库时长=近7天已出库包裹的（转运中心出库时间-转运中心入库时间）的平均值，仅统计已出库包裹；
          库存时长=当前时间-转运中心入库时间；库存年龄结构仅统计当前仍未出库的包裹。
       -->
      {{ $t('collectionCenter.hubVal27') }}
    </div>

    <!-- 库存年龄结构——光标移入时展示 -->
    <div
      v-show="barMsgVisible"
      class="bartip_box"
      :style="{ left: tooltipX + 'px', top: tooltipY + 'px' }"
    >
      <div class="bartip_content"><span :class="barMsgColor" class="color_card" /> {{ barMsgData.bucketName }}</div>
      <div>{{ $t('collectionCenter.ballot') }}：{{ formatThousand(barMsgData.ticketCount) }}</div>
      <div>{{ $t('trajectory.Proportion') }}：{{ formatThousand(barMsgData.rate) }}%</div>
    </div>
  </div>
</template>

<script>
import { regionQueryList, getLgAreaListData, getSiteTransfer, chartData, chartExport } from '@/api/orderApi';
import { goRWExportList } from '@/utils/goExportList.js';

export default {
  // name: 'Xxxxx',
  components: {
    hubTable: () => import('./table'),
    barChart: () => import('./barImg')
  },
  data() {
    return {
      barMsgColor: '',
      barMsgData: {},
      tooltipTimer: null,
      barMsgVisible: false,
      tooltipX: 0,
      tooltipY: 0,
      screenWidth: 0,
      interval: null,
      updateTime: '',
      regionData: [],
      stateData: [],
      departmentData: [],
      queryForm: {
        dashboardType: 'HUB_STOCK_DASHBOARD',
        chartType: '',
        params: {
          areaNameList: '',
          stateList: [],
          hubLevelList: '',
          departmentList: []
        },
        pageNumber: 1,
        pageSize: 50
      },
      globalOverviewValue: {},
      globalOverviewData: [
        //                           今日入库票数                                                    今日进入转运中心的包裹总量。
        { data1: this.$t('collectionCenter.todayInboundTickets'), data2: 'inboundTicketCount', data3: this.$t('collectionCenter.hubVal32'), color: '#172033' },
        //                           今日出库票数                                                    今日从转运中心发出的包裹总量。
        { data1: this.$t('collectionCenter.todayOutboundTickets'), data2: 'outboundTicketCount', data3: this.$t('collectionCenter.hubVal33'), color: '#172033' },
        //                           当前库存票数                                                    当前仍停留在转运中心且未发出的包裹。
        { data1: this.$t('collectionCenter.currentInventoryTickets'), data2: 'currentTicketCount', data3: this.$t('collectionCenter.hubVal34'), color: '#d92d20' },
        //                           库存周转天数                                                    当前库存票数 ÷ 近7日日均出库票数。
        { data1: this.$t('collectionCenter.inventoryTurnoverDays'), data2: 'stockTurnoverDays', data3: this.$t('collectionCenter.hubVal35'), color: '#dc6a08' },
        //                           近7天平均在库时长                                                近7天已出库包裹，从入库到出库的平均耗时。
        { data1: this.$t('collectionCenter.avgStorageTimeLast7Days'), data2: 'avgInventoryHours', data3: this.$t('collectionCenter.hubVal36'), color: '#dc6a08' },
        //                           净增库存                                                        出库票数 - 入库票数。
        { data1: this.$t('collectionCenter.netInventoryIncrease'), data2: 'netIncreaseTicketCount', data3: this.$t('collectionCenter.hubVal37'), color: '#dc6a08' },
        //                           库存老化率                                            超过48小时库存票数 ÷ 实时库存票数，用于衡量库存积压风险。
        { data1: this.$t('collectionCenter.inventoryAgingRate'), data2: 'inventoryAgingRate', data3: this.$t('collectionCenter.hubVal38'), color: '#d92d20' }
      ],
      ageStructureData: [ // 调接口后添加【ticketCount、rate】
        { bucketName: '≤24h', background: '#f8fafc', borderColor: '#e6eaf0' },
        { bucketName: '24~48h', background: '#f8fafc', borderColor: '#e6eaf0' },
        { bucketName: '48~72h', background: '#fffaf5', borderColor: '#fed7ab' },
        { bucketName: '3~7' + this.$t('basicData.NumberOfDays'), background: '#fffaf5', borderColor: '#fed7ab' },
        { bucketName: '>7' + this.$t('basicData.NumberOfDays'), background: '#fff7f7', borderColor: '#fecaca' }
      ],
      lineData: [], // 将返回的【rate】转为百分数
      levelData: [
        { progress: 0, title: this.$t('collectionCenter.hubVal28'), currentTicketCount: 0 },
        { progress: 0, title: this.$t('collectionCenter.hubVal29'), currentTicketCount: 0 },
        { progress: 0, title: this.$t('collectionCenter.hubVal30'), currentTicketCount: 0 }
      ], // 前端计算百分数（需要考虑最小值也能展示）
      highRiskData: [],
      agingRiskData: [],
      barData: {},
      tableData: [],
      filterData: {}
    };
  },
  created() {
    this.getRegion();
    this.getState();
    this.getDepartment();
    this.searchForm();
  },
  mounted() {
    this.screenWidth = window.innerWidth;
    // eslint-disable-next-line no-return-assign
    window.onresize = () => this.screenWidth = window.innerWidth;
    // 自动刷新：1小时
    this.interval = setInterval(() => {
      this.searchForm();
    }, 60 * 60 * 1000);
  },
  beforeDestroy() {
    window.onresize = null;
    clearInterval(this.interval);
    this.interval = null;
  },
  methods: {
    searchForm() {
      const form = JSON.parse(JSON.stringify(this.queryForm));
      form.params.areaNameList = this.queryForm.params.areaNameList ? [this.queryForm.params.areaNameList] : [];
      form.params.hubLevelList = this.queryForm.params.hubLevelList ? [this.queryForm.params.hubLevelList] : [];
      this.allSearch(form);
    },
    async allSearch(form) {
      /**
       * 全局概览 hubStockOverview
       * 库存年龄与层级库存 hubStockAgeLevel
       * 高库存风险 TOP10 + 库存老化风险 TOP10 hubStockRiskTop
       * 近7日入库/出库趋势 hubStockTrend7Days
       * 转运中心明细 hubStockDetail
     */
      const type = ['hubStockOverview', 'hubStockAgeLevel', 'hubStockRiskTop', 'hubStockTrend7Days', 'hubStockDetail', 'updateTime'];
      try {
        const [r1, r2, r3, r4, r5, r6] = await Promise.all([
          chartData({ ...form, chartType: type[0] }).catch(e => (console.error(`type ${type[0]}错误`, e))),
          chartData({ ...form, chartType: type[1] }).catch(e => (console.error(`type ${type[1]}错误`, e))),
          chartData({ ...form, chartType: type[2] }).catch(e => (console.error(`type ${type[2]}错误`, e))),
          chartData({ ...form, chartType: type[3] }).catch(e => (console.error(`type ${type[3]}错误`, e))),
          chartData({ ...form, chartType: type[4] }).catch(e => (console.error(`type ${type[4]}错误`, e))),
          chartData({ ...form, chartType: type[5] }).catch(e => (console.error(`type ${type[5]}错误`, e)))
        ]);
        this.fnOne(r1.data.chartData);
        this.fnTwo(r2.data.chartData);
        this.fnThree(r3.data.chartData);
        this.fnFour(r4.data.chartData);
        this.fnFive(r5.data.chartData);
        this.updateTime = r6.data.chartData;
      } finally {
        //
      }
    },
    // 全局概览
    fnOne(res) {
      if (res) {
        res.inventoryAgingRate = res.inventoryAgingRate * 100;
        this.globalOverviewValue = res;
      } else {
        this.globalOverviewValue = {};
      }
    },
    // 库存年龄与层级库存
    fnTwo(res) {
      // 库存年龄结构
      if (res.ageList && res.ageList.length > 0) {
        this.lineData = [];
        res.ageList.forEach((item, idx) => {
          this.ageStructureData[idx].ticketCount = item.ticketCount;
          this.ageStructureData[idx].rate = item.rate * 100;
          this.lineData.push(item.rate * 100 + '%');
        });
        console.log(this.ageStructureData, ' =====库存年龄结构', this.lineData);
      } else {
        this.ageStructureData.forEach(item => {
          item.ticketCount = 0;
          item.rate = 0;
        });
        this.lineData = [];
      }

      // 转运中心层级库存
      if (res.levelList && res.levelList.length > 0) {
        const progress = res.levelList.map(item => {
          return item.currentTicketCount;
        });
        console.log(progress, '=====转运中心层级库存progress');
        const totalValue = progress.reduce((sum, count) => sum + count, 0);
        const progressList = res.levelList.map(item => {
          let pg = (item.currentTicketCount / totalValue) * 100;
          pg = Math.round(pg);
          return pg;
        });
        console.log(progressList, '=====转运中心层级库存progressList');
        const titleKeys = [
          this.$t('collectionCenter.hubVal28'),
          this.$t('collectionCenter.hubVal29'),
          this.$t('collectionCenter.hubVal30')
        ];
        this.levelData = progressList.map((progress, index) => ({
          progress: progress,
          title: titleKeys[index] || '',
          currentTicketCount: res.levelList[index].currentTicketCount
        }));
        // 补充空数据
        while (this.levelData.length < 3) {
          const emptyIndex = this.levelData.length;
          this.levelData.push({
            progress: 0,
            title: titleKeys[emptyIndex],
            currentTicketCount: 0
          });
        }
      } else {
        this.levelData = [
          { progress: 0, title: this.$t('collectionCenter.hubVal28'), currentTicketCount: 0 },
          { progress: 0, title: this.$t('collectionCenter.hubVal29'), currentTicketCount: 0 },
          { progress: 0, title: this.$t('collectionCenter.hubVal30'), currentTicketCount: 0 }
        ];
      }
    },
    // 高库存风险 TOP10 + 库存老化风险 TOP10。
    fnThree(res) {
      // 高库存风险HUB TOP10
      this.highRiskData = res.highStockList;
      this.agingRiskData = res.agingRiskList.map(item => {
        item.inventoryAgingRate = this.formatThousand(item.inventoryAgingRate * 100);
        return item;
      });
    },
    fnFour(res) {
      if (res && res.length > 0) {
        const statDate = [];
        const inboundTicketCount = []; // 入库票数
        const outboundTicketCount = []; // 出库票数
        const currentTicketCount = []; // 当前库存票数
        res.forEach(item => {
          statDate.push(item.statDate);
          inboundTicketCount.push(item.inboundTicketCount);
          outboundTicketCount.push(item.outboundTicketCount);
          currentTicketCount.push(item.currentTicketCount);
        });
        this.barData = {
          statDate,
          inboundTicketCount,
          outboundTicketCount,
          currentTicketCount
        };
      } else {
        this.barData = {};
      }
    },
    fnFive(res) {
      this.tableData = res.map(item => {
        item.inventoryAgingRate = this.formatThousand(item.inventoryAgingRate * 100);
        return item;
      });
    },
    // 库存年龄结构 进度条指示气泡
    showEchartsTooltip(event, data, color) {
      if (this.tooltipTimer) clearTimeout(this.tooltipTimer);
      this.barMsgData = data;
      this.barMsgColor = color;
      this.barMsgVisible = true;
      this.tooltipX = event.clientX + 15;
      this.tooltipY = event.clientY - 40;
    },
    hideEchartsTooltip() {
      this.tooltipTimer = setTimeout(() => {
        this.barMsgVisible = false;
      }, 200); // 避免闪烁
    },
    exportData(type) {
      if (this.tableData.length <= 0) {
        this.$message.warning(this.$t('collectionCenter.noDataExport'));
        return;
      }
      const form = JSON.parse(JSON.stringify(this.queryForm));
      form.params.areaNameList = this.queryForm.params.areaNameList ? [this.queryForm.params.areaNameList] : [];
      form.params.hubLevelList = this.queryForm.params.hubLevelList ? [this.queryForm.params.hubLevelList] : [];
      form.chartType = type;
      delete form.params.pageNumber;
      delete form.params.pageSize;
      chartExport(form).then(res => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    },

    changeRegion(val) {
      this.queryForm.params.stateList = [];
      this.queryForm.params.departmentList = [];
      if (val && this.regionData.length > 0) {
        const selectedRegion = this.regionData.find(item => item.zhName === val);
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          this.stateData = selectedRegion.states.map(state => ({
            label: state
          }));
        }
        this.departmentData = selectedRegion?.sites || [];
        this.groupSitesByRegionAndState();
      } else {
        this.getState();
        this.getDepartment();
      }
    },
    changeState(val) {
      this.queryForm.params.departmentList = [];
      const regionId = this.queryForm.params.areaNameList;
      if (regionId && (!val || val.length <= 0)) {
        const selectedRegion = this.regionData.find(r => r.zhName === regionId);
        this.departmentData = selectedRegion?.sites || [];
      }
      if (regionId && val && val.length > 0) {
        const mergedSites = [];
        val.forEach(state => {
          const sitesInState = this.filterData[regionId]?.[state] || [];
          mergedSites.push(...sitesInState);
        });
        this.departmentData = mergedSites;
      }
    },
    // 千分位符号处理
    formatThousand(value) {
      if (!value && value !== 0) return value;
      const num = typeof value === 'number' ? value : parseFloat(String(value));
      if (isNaN(num)) return value;

      if (this.$i18n.locale === 'zh') {
        return num.toLocaleString('en-US');
      } else {
        return num.toLocaleString('de-DE');
      }
    },
    // 过滤
    groupSitesByRegionAndState() {
      const grouped = {};
      this.regionData.forEach((region) => {
        if (!grouped[region.zhName]) {
          grouped[region.zhName] = {};
        }
        region.sites.forEach((site) => {
          const key = site.state; // 区分大小写
          if (!grouped[region.zhName][key]) {
            grouped[region.zhName][key] = [];
          }
          grouped[region.zhName][key].push(site);
        });
      });
      this.filterData = grouped;
    },
    getRegion() {
      regionQueryList(2).then(res => {
        if (res.code === 200) {
          this.regionData = res.data;
        }
      });
    },
    getState() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.stateData = res.data.map(item => {
            return {
              label: item.nameEn
            };
          });
        }
      });
    },
    getDepartment() {
      getSiteTransfer().then(res => {
        if (res.code === 200) {
          this.departmentData = res.data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.bartip_box {
  position: fixed;background: rgba(0, 0, 0, 0.85);backdrop-filter: blur(4px); // 背景模糊
  color: white;padding: 10px 14px;border-radius: 6px;font-size: 12px;pointer-events: none;z-index: 1000;box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  border: 1px solid rgba(255,255,255,0.1);box-sizing: border-box;min-width: 150px;animation: tooltipFade 0.15s ease;
  .bartip_content {
    color: white;border-bottom: 1px solid #434a4d;padding-bottom: 10px;margin-bottom: 10px;box-sizing: border-box;
  }
}
@keyframes tooltipFade {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.Box{
  grid-template-rows: auto 1fr auto;min-height: 100%;
  background: #f4f6fa;padding: 20px;box-sizing: border-box;
}
.mt20 .top_title_time { margin: 15px 0; }
.top_title {
  display: flex;justify-content: space-between;align-items: self-start;
}
.top_title_top { font-size: 20px;line-height: 20px; font-weight: bold;color: #172033; }
.top_title_bottom { font-size: 13px;color: #667085; }
.top_title_time {
  border-radius: 12px; border: 1px solid #e6eaf0; box-shadow: 5px 5px 10px rgba(0,0,0,0.05);
  background: #fff; padding: 12px 14px;color: #475467;font-size: 13px;line-height: 13px;
}
.top_title_time_split { color: #636eae;margin: 0 3px;font-size: 15px;line-height: 15px; }
.form_box {
  border-radius: 12px; border: 1px solid #e6eaf0; box-shadow: -2px 4px 10px rgba(0,0,0,0.05);
  padding: 10px;background: #fff;margin: 10px 0;box-sizing: border-box;
}
.form_box ::v-deep .el-form-item { margin-bottom: 0 !important; }
.form_box ::v-deep .el-form-item__label { line-height: 15px;color: #667085; }
.form_box ::v-deep .el-input__inner { border-radius: 8px;box-sizing: border-box; }
.form_box ::v-deep .el-input__inner::placeholder { color: #344054; }
.search_btn {
  width: 100px;border-radius: 8px; margin-top: 18px;
  font-size: 15px;font-weight: bold;line-height: 13px;box-sizing: border-box;
}
.allW {
  width: 100%;border-radius: 8px; margin-top: 0;
  font-size: 15px;font-weight: bold;line-height: 13px;box-sizing: border-box;
}

.title_bw_bold.ind { font-size: 18px; }
.title_bw {
  display: flex;justify-content: space-between;align-items: center;margin: 17px 0 5px;
}
.title_bw_bold { font-size: 16px;font-weight: bold;color: #20293b; }
.title_bw_tips { font-size: 13px;color: #667085; }
.grid-seven {
  display: flex;flex-wrap: wrap;gap: 10px;
}
.grid-item7 {
  border-radius: 12px; border: 1px solid #e6eaf0; box-shadow: 1px 5px 10px rgba(0,0,0,0.05);
  padding: 10px;background: #fff;box-sizing: border-box;flex: 1;
}
.gi7 { border-radius: 12px; border: 1px solid #e6eaf0; box-shadow: 1px 5px 10px rgba(0,0,0,0.05);
  padding: 10px;background: #fff;box-sizing: border-box; margin-top: 10px;width: 100% }

.grid_item_gray { font-size: 12px; line-height: 12px; color: #667085; }
.grid_item_bold { font-size: 25px; line-height: 25px; font-weight: 700; }
.box_class {
  border-radius: 12px; border: 1px solid #e6eaf0; box-shadow: 1px 5px 10px rgba(0,0,0,0.05);
  padding: 10px;background: #fff;box-sizing: border-box;
}
.grid-five {display: flex;flex-wrap: wrap;gap: 10px;margin-top: 10px;}
.grid-item5 {border-radius: 12px;border: 1px solid #e6eaf0;padding: 10px;box-sizing: border-box;flex: 1;}
.gi5 { border-radius: 12px;border: 1px solid #e6eaf0;padding: 10px;box-sizing: border-box;width: 100% }

.bg_box {
  width: 100%;height: 15px;line-height: 15px;border-radius:10px;overflow: hidden;margin-top: 15px;box-sizing: border-box;white-space: nowrap;
}
.bg_green,.bg_blue,.bg_Pumpkin,.bg_orange,.bg_red { height: 100%;display: inline-block; }
.bg_green { background: #16a34a; }
.bg_blue { background: #2563eb; }
.bg_Pumpkin { background: #dc6803; }
.bg_orange { background: #ea580c; }
.bg_red { background: #d92d20; }
.color_card { border-radius: 3px;box-sizing: border-box;display: inline-block; width: 11px; height: 11px; }
.bg_card { margin-top: 12px;display: flex;align-items: center;gap: 15px;font-size: 13px;color: #667085; }

.progress_class {
  margin-top: 10px;display: flex;justify-content: space-between;align-items: center;
  .progress_title { font-size: 13px;color: #344054;margin-right: 10px; }
  .progress_num { font-size: 16px;color: #172033;font-weight: 700;text-align: right;}
}
.progress_gray_box {
  border: 1px dashed #cbd5e1; border-radius: 12px;padding: 10px;
  box-sizing: border-box; margin-top:20px;background: #f8fafc;
  color: #667085;font-size: 13px;
  .progress_gray_text { color: #172033;font-size: 13px; font-weight: bold; }
}

.risk_box {
  max-height: 500px;overflow-y: auto;
  .risk_item {
    min-height: 50px;border-bottom: 1px solid #eef2f6;padding: 13px 0 8px;box-sizing: border-box;
    display: flex;justify-content: space-between;align-items: center;
  }
  .risk_index {
    display: inline-block;width: 25px;height: 25px;border-radius: 7px;background: #f2f4f7;
    font-size: 13px;line-height: 25px;font-weight: 800;color: #667085;text-align: center;margin-right: 15px;
  }
  .risk_content { flex: 1; margin-right: 10px; }
  .risk_name { color: #172033;font-size: 15px;font-weight: 700;line-height: 15px; }
  .risk_num { display: inline-block;margin: 0 5px; }
  .risk_day { font-size: 13px;font-weight: 600;padding: 2px 8px;border-radius: 15px; }
}
</style>
